module.exports = __webpack_public_path__ + "img/campus-1.752749d3.png";